export const areAllIdsNumbers = (data) => {
  let allIdsAreNumbers = true;

  Object.keys(data).forEach(key => {
    if (key.endsWith("_id")) {
      const val = data[key];
      if (typeof val !== "number" || isNaN(val)) {
        allIdsAreNumbers = false;
      }
    }
  });

  return allIdsAreNumbers;
};
